<app-intro></app-intro>
<app-statistics></app-statistics>
<div fxLayout="row">
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex.gt-sm="70" fxFlexOffset.gt-sm="15" ngClass.sm="sm" ngClass.xs="xs">
        <app-news fxFlex.gt-sm="70" fxFlex.lt-md="100" ngClass.gt-sm="news-section"></app-news>
        <app-db-updates fxFlex="30" fxFlex.lt-md="100" class="db-update-section"></app-db-updates>
    </div>
</div>
<div class="get-involved-wrapper" fxLayout="row" fxLayoutAlign="center center" ngClass.gt-sm="desktop">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign.xs="start stretch" class="get-involved w-100" fxFlex.gt-sm="70" ngClass.gt-md="desktop" ngClass.sm="wrap-sm" fxFlex.sm>
        <div fxFlex.gt-xs="50%" fxFlex.xs class="image"></div>
        <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxFlex ngClass.xs="xs" class="text" ngClass.gt-md="desktop">
            <h2>Get Involved</h2>
            <div>
                Would you like to learn more about MARIS? Do you have data that you would like to share with other MARIS users? Get in touch to learn how you can contribute to global marine
                radioactivity science and research.
            </div>
            <div class="button" fxLayout="row" fxLayoutAlign="center center">
                <a routerLink="/get-involved">Get in touch</a>
            </div>
        </div>
    </div>
</div>
